import React, { Fragment } from 'react'
import {AppTabs}from 'qcc'
import {DemoApiTable} from './DemoApiTable'
import { Row, Icon } from 'antd';
import { AppGridSearch } from 'components/AppTableSearch/AppGridSearch'

const dataList = ['Tab1','Tab2','Tab3']

export const AppTabsDemo = () =>{
    return (<div className='app-demo-content'>
            <h1>使用说明</h1>    
            <div>
                1、Tab标签页<br/>
                2、引用：import {`{AppTabs}`} from 'qcc'<br/>
                3、demo位置：src/demo/components/AppTabsDemo.tsx<br/>
            </div>

            <h1>DEMO</h1>
            <div className='app-demo-content-demo'>
                <Row  className="demo-title">
                   
                    <Row style={{padding:20,paddingTop:0}}>
                        <div style={{width:600}}>
                            <AppTabs tabs={dataList}/>
                        </div>
                    </Row>
                </Row>
            </div>
            
            <h1>API</h1>
            
    </div>)
}


// WEBPACK FOOTER //
// ./src/demo/components/AppTabsDemo.tsx